"use client"

import * as React from "react"

// import { NavMain } from "@/components/nav-main"
// import { NavProjects } from "@/components/nav-projects"
// import { NavUser } from "@/components/nav-user"
// import { TeamSwitcher } from "@/components/team-switcher"
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarRail
} from "@/components/ui/sidebar"
import { NavLink } from "react-router-dom"
import { Logo } from "./logo.component"
import { NavMain } from "./nav-main.component"
import { NavUser } from "./nav-user.component"

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {

    return (
        <Sidebar collapsible="icon" {...props}>
            <SidebarHeader className="flex justify-center items-center">
                <NavLink to="/dashboard" aria-label="logo" className="min-w-10 max-w-full overflow-hidden">
                    <Logo
                        className='group-data-[state=collapsed]:origin-[10%_50%] fill-primary h-10 hover:scale-[1.1] origin-[60%_50%] transition-all -translate-x-[10%] group-data-[state=collapsed]:translate-x-[0] duration-500 ease-in-out delay-300'

                    />
                </NavLink>
                {/* <TeamSwitcher teams={data.teams} /> */}
            </SidebarHeader>
            <SidebarContent>
                <NavMain />
            </SidebarContent>
            <SidebarFooter>
                <NavUser />
            </SidebarFooter>
            <SidebarRail />
        </Sidebar>
    )
}
